import { StoreAtom } from 'ketshopweb-sdk'

export const IsSandClockBooks = StoreAtom<boolean>([
  'sandclockbooks.com', 
  'sandclockbooks.ketshoptest.com'
].includes(location.host) || localStorage.getItem('_sandclock') === 'true')